var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "offer-search" }, [
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.showAllOffersToggle,
            expression: "showAllOffersToggle"
          }
        ],
        staticClass: "checkbox-input",
        attrs: { type: "checkbox", value: "true" },
        domProps: {
          checked: Array.isArray(_vm.showAllOffersToggle)
            ? _vm._i(_vm.showAllOffersToggle, "true") > -1
            : _vm.showAllOffersToggle
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.showAllOffersToggle,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "true",
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.showAllOffersToggle = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.showAllOffersToggle = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.showAllOffersToggle = $$c
              }
            },
            function($event) {
              return _vm.toggleShowAllOffers()
            }
          ]
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "checkbox-label" }, [
        _vm._v(_vm._s(_vm.$modeoL10n.all_offers))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "offer-search__details" }, [
      _c("div", { staticClass: "offer-search__labels" }, [
        _c(
          "p",
          {
            staticClass:
              "availability availability--small availability--inline availability--light"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.statusLabels["offer-draft"]) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "availability availability--small availability--inline availability--positive"
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.statusLabels["offer"]) + "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "offer-search__count" }, [
        _vm._v(
          "\n      Näytetään " + _vm._s(_vm.foundPosts) + " tarjousta\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "woocommerce-orders-table woocommerce-orders-table--offers"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.offers, function(offer) {
            return _c(
              "tr",
              {
                key: offer.id,
                staticClass:
                  "woocommerce-orders-table__row woocommerce-orders-table__row--link order",
                class: [
                  "woocommerce-orders-table__row--status-" + offer.status,
                  { "status-has-hover": _vm.offerHover }
                ],
                on: {
                  click: function($event) {
                    return _vm.selectOffer(offer)
                  }
                }
              },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell-order-status"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "woocommerce-orders-table__cell-order-status-text"
                      },
                      [_vm._v(_vm._s(_vm.statusLabels[offer.status]))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell--highlight",
                    class: {
                      "woocommerce-orders-table__cell--inactive": !offer.customer_reference
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(offer.customer_reference || "Ei viitettä") +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell--highlight"
                  },
                  [_vm._v("\n          WC-" + _vm._s(offer.id) + "\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell--highlight",
                    class: {
                      "woocommerce-orders-table__cell--inactive": !offer.billing_company
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "woocommerce-orders-table__mobile" },
                      [_vm._v("Asiakas: ")]
                    ),
                    _vm._v(
                      "\n          " +
                        _vm._s(offer.billing_company || "-") +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "woocommerce-orders-table__cell" }, [
                  _c(
                    "span",
                    { staticClass: "woocommerce-orders-table__mobile" },
                    [_vm._v("Myyjä: ")]
                  ),
                  _vm._v(
                    "\n          " +
                      _vm._s(offer.salesperson.first_name || "-") +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell-order-date"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "woocommerce-orders-table__mobile" },
                      [_vm._v("Luotu: ")]
                    ),
                    _vm._v(" "),
                    _c("time", { attrs: { datetime: offer.created_date } }, [
                      _vm._v(_vm._s(_vm._f("formatDate")(offer.created_date)))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell-order-date"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "woocommerce-orders-table__mobile" },
                      [_vm._v("Voimassa: ")]
                    ),
                    _vm._v(" "),
                    _c("time", { attrs: { datetime: offer.offer_expiry } }, [
                      _vm._v(_vm._s(offer.offer_expiry || "-"))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell-order-total"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "woocommerce-Price-amount amount" },
                      [
                        _vm._v(
                          _vm._s(_vm._f("formatPrice")(offer.totals.subtotal))
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "woocommerce-orders-table__cell woocommerce-orders-table__cell-actions"
                  },
                  [
                    _c("offer-actions-menu", {
                      attrs: {
                        "offer-id": offer.id,
                        nonce: _vm.nonce,
                        "current-user-can-delete":
                          _vm.currentUserIsAdmin ||
                          _vm.currentUserId == offer.salesperson.id
                      },
                      nativeOn: {
                        mouseover: function($event) {
                          _vm.offerHover = false
                        },
                        mouseout: function($event) {
                          _vm.offerHover = true
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Tila\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Asiakkaan viite\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Tarjousnro\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Asiakas\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Myyjä\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Luotu\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Voimassa\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _vm._v("\n          Hinta\n        ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "woocommerce-orders-table__header" }, [
          _c("span", { staticClass: "screen-reader-text" }, [
            _vm._v("Toimenpiteet")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17a5338f", { render: render, staticRenderFns: staticRenderFns })
  }
}